import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Field from "../../../../components/Field";
import Select from "../../../../components/Inputs/Select";
import Text from "../../../../components/Inputs/Text";
import { renderPeopleCustomFieldLabel } from "../../../../utils/helpers/settings";
import { useCustomFields } from "../../../Settings/CustomFields/context";

function CustomFields() {
    const { t } = useTranslation();
    const { peopleCustomFields } = useCustomFields();

    const input = useCallback((field) => {
        let Component;
        const placeholder = renderPeopleCustomFieldLabel(field);
        switch (field.type) {
            case "number":
                Component = <Text type="number" min={0} placeholder={placeholder} />
                break;
            case "email":
                Component = <Text type="email" placeholder={placeholder} />
                break;
            case "select":
                Component = (
                    <Select placeholder={placeholder} allowClear>
                        {field.options.map((option) => (
                            <Select.Option value={option.value} key={option.value}>
                                {option.label}
                            </Select.Option>
                        ))}
                    </Select>
                );
                break;
            case "text":
            default:
                Component = <Text placeholder={placeholder} />
                break;
        }
        return Component
    }, []);

    const rules = useCallback((field) => {
        const values = [
            {
                required: field.isRequired,
                message: t("required-custom-field-type", {
                    code: renderPeopleCustomFieldLabel(field),
                })
            }
        ];

        if (field.type === "email") {
            values.push({
                type: "email",
                message: t("invalid-email"),
            });
        }

        if (field.type === "number") {
            values.push({
                min: 0,
                message: t("custom-field-bigger-than-0", {
                    code: renderPeopleCustomFieldLabel(field),
                })
            })
        }

        return values;
    }, [t]);

    return peopleCustomFields?.length > 0 && (
        <div className="w-100">
            <hr />

            <h5 className="mb-3 text-muted font-weight-400 text-uppercase">
                {t("custom-fields")}
            </h5>

            <div
                className="px-4"
                style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: 30 }}
            >
                {peopleCustomFields.map((field) => (
                    <Field
                        label={renderPeopleCustomFieldLabel(field)}
                        name={["customFields", field.code]}
                        rules={rules(field)}
                    >
                        {input(field)}
                    </Field>
                ))}
            </div>
        </div>
    );
}

export default CustomFields;
